module.exports = __webpack_public_path__ + "static/img/company-img-2.cd701554.png";